module.exports = __webpack_public_path__ + "static/media/15_negro.1ddff1f4.svg";